import { SUB_MATCH_DATE_DIFF } from '@okletsplay/core';
import { array, date, mixed, number, object } from 'yup';
import { createBaseTournamentValidationSchema } from 'modules/tournaments/validators';
import { UserBalanceValidationOptions } from 'modules/payments/validators';

export const createBaseKnockoutTournamentSchema = (options: UserBalanceValidationOptions) => {
  return createBaseTournamentValidationSchema(options).shape({
    startedAt: mixed().test({
      name: 'startedAt',
      message: 'Start time must be in the future.',
      test: function (value) {
        return new Date().getTime() < value?.getTime();
      },
    }),
    subMatchesSettings: array().of(
      object({
        round: number().required(),
        bestOf: number().required(),
        startedAt: date().nullable(),
      })
        .matchDate(
          `Difference between two dates should be more than ${SUB_MATCH_DATE_DIFF / 3600} hours`
        )
        .required()
    ),
  });
};
